import { useMemo } from "react";

export function useSameWidthModifiers() {
  return useMemo(
    () => [
      {
        name: "sameWidth",
        enabled: true,
        phase: "beforeWrite" as const,
        requires: ["computeStyles"],
        fn({ state }: any) {
          state.styles.popper.minWidth = `${state.rects.reference.width}px`;
        },
        effect({ state }: any) {
          state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`;
        },
      },
    ],
    []
  );
}
